import React from "react";
import { connect } from "react-redux";
import { getLenndFlags } from "redux/modules/lenndFlags/selectors";
import * as flagConstants from "utils/feature-flags";

const FeatureFlagList = ({ allFlags }) => {
  const flagDefinitions = Object.values(flagConstants);

  return (
    <div
      style={{
        padding: 20,
        background: "#f5f5f5",
        width: "100%",
        borderRadius: 4
      }}
    >
      <h3>Feature Flag Status</h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        {flagDefinitions.map(flag => (
          <div
            key={flag.NAME}
            style={{
              padding: 10,
              background: "white",
              borderRadius: 4,
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <span>{flag.NAME}:</span>
            <span
              style={{
                color: allFlags[flag.NAME] ? "green" : "red",
                fontWeight: "bold"
              }}
            >
              {allFlags[flag.NAME] ? "ON" : "OFF"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  allFlags: getLenndFlags(state)
});

export default connect(mapStateToProps)(FeatureFlagList);
